import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { type CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthStore } from './auth.store';

export function safeReturnUrl(value: string | null | undefined): string {
    return value && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/login') ? value : '/';
}

function whenInitialized() {
    const auth = inject(AuthStore);
    return toObservable(auth.initialized).pipe(
        filter(Boolean),
        take(1),
        map(() => auth),
    );
}

export const authGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);
    return whenInitialized().pipe(
        map((auth) =>
            auth.loggedIn() ? true : router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }),
        ),
    );
};

export const guestGuard: CanActivateFn = (route) => {
    const router = inject(Router);
    return whenInitialized().pipe(
        map((auth) => (auth.loggedIn() ? router.parseUrl(safeReturnUrl(route.queryParamMap.get('returnUrl'))) : true)),
    );
};
